var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { val: _vm.value_ } }, [
    _c(
      "div",
      [
        _c(
          "el-radio",
          {
            attrs: { label: "1", size: "mini", border: "" },
            model: {
              value: _vm.type,
              callback: function ($$v) {
                _vm.type = $$v
              },
              expression: "type",
            },
          },
          [_vm._v("每年")]
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "el-radio",
          {
            attrs: { label: "5", size: "mini", border: "" },
            model: {
              value: _vm.type,
              callback: function ($$v) {
                _vm.type = $$v
              },
              expression: "type",
            },
          },
          [_vm._v("不指定")]
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "el-radio",
          {
            attrs: { label: "2", size: "mini", border: "" },
            model: {
              value: _vm.type,
              callback: function ($$v) {
                _vm.type = $$v
              },
              expression: "type",
            },
          },
          [_vm._v("周期")]
        ),
        _c(
          "span",
          { staticStyle: { "margin-left": "10px", "margin-right": "5px" } },
          [_vm._v("从")]
        ),
        _c("el-input-number", {
          staticStyle: { width: "100px" },
          attrs: { min: 2000, size: "mini" },
          on: {
            change: function ($event) {
              _vm.type = "2"
            },
          },
          model: {
            value: _vm.cycle.start,
            callback: function ($$v) {
              _vm.$set(_vm.cycle, "start", $$v)
            },
            expression: "cycle.start",
          },
        }),
        _c(
          "span",
          { staticStyle: { "margin-left": "5px", "margin-right": "5px" } },
          [_vm._v("至")]
        ),
        _c("el-input-number", {
          staticStyle: { width: "100px" },
          attrs: { min: 2000, size: "mini" },
          on: {
            change: function ($event) {
              _vm.type = "2"
            },
          },
          model: {
            value: _vm.cycle.end,
            callback: function ($$v) {
              _vm.$set(_vm.cycle, "end", $$v)
            },
            expression: "cycle.end",
          },
        }),
        _vm._v(" 年 "),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }